import React from 'react';
import css from '../ListingPage.module.css';
import { formatNumberCompact, isArrayLength } from '../../../util/genericHelpers';
import { Icons } from '../../../components';

// Utility to generate a random string for key uniqueness
const generateRandomKey = () =>
  Math.random()
    .toString(36)
    .substring(2, 10);

function RenderSocials({ socialHandlesMaybe }) {
  // Early return if socialHandlesMaybe is not a valid array
  if (!isArrayLength(socialHandlesMaybe)) {
    return null;
  }

  return (
    <div className={css.socialShare}>
      {socialHandlesMaybe.map((social, index) => {
        // Ensure social object and required properties exist
        if (!social || !social.platform || !social.followers) {
          return null;
        }

        // Generate a unique key using a random string and the index
        const uniqueKey = `${social.platform}-${generateRandomKey()}-${index}`;
        const formattedFollowers = formatNumberCompact(social.followers);

        return (
          <span key={uniqueKey} className={css.socialItem}>
            <Icons name={social.platform} className={css.socialIcon} />
            <span className={css.followersCount}>
              {formattedFollowers && ` ${formattedFollowers}`}
            </span>
          </span>
        );
      })}
    </div>
  );
}

export default RenderSocials;
